/* eslint-disable react/no-this-in-sfc */
import React, { useState } from 'react';
import Highcharts from 'highcharts';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { Box, CircularProgress, Divider, Paper } from '@material-ui/core';
import ShowMoreButton from './utils/ShowMoreButton';
import { barChartBase } from './utils/barChartBase';
import ShippedItemsPackageDialog from './ShippedItemsPackageDialog';
import PeriodicityButton from './utils/PeriodicityButton';
import ExportCsvButton from './utils/ExportCsvButton';
import { exportToCsv, exportToExcel } from './utils/csvExport';
import { getShippedByCarrier } from '../dashboardActions';

const ShippedPackageChart = ({
  shippedQuantitiesByCarrier,
  dispatchGetShippedByCarrier,
  loadingShippedQuantitiesByCarrier
}) => {
  const [
    shippedItemsPackageDialog,
    setShippedItemsPackageDialogOpen
  ] = useState(false);
  const totalShipped = shippedQuantitiesByCarrier.reduce(
    (a, b) => +a + +b.quantity,
    0
  );
  const options = {
    ...barChartBase,
    xAxis: {
      ...barChartBase.xAxis,
      labels: {
        useHTML: true,
        align: 'center',
        // eslint-disable-next-line
        formatter: function() {
          return `<img src=${
            shippedQuantitiesByCarrier[this.pos].carrier.logoUrl
          } style="width: 50px;"></img>`;
        }
      },
      categories: shippedQuantitiesByCarrier
        .slice(0, 8)
        .map(s => s.carrier.name)
    },
    yAxis: {
      ...barChartBase.yAxis,
      stackLabels: {
        ...barChartBase.yAxis.stackLabels,
        // eslint-disable-next-line
        formatter: function() {
          // eslint-disable-next-line react/no-this-in-sfc
          return `${((this.total * 100) / totalShipped).toFixed(2)} %`;
        }
      }
    },
    series: [
      {
        name: 'Transporteur',
        data: shippedQuantitiesByCarrier.slice(0, 8).map(s => ({
          name: s.carrier.name,
          color: s.carrier.color || '#3D59A8',
          y: s.quantity
        }))
      }
    ]
  };

  return (
    <div>
      <ShippedItemsPackageDialog
        open={shippedItemsPackageDialog}
        handleClose={() => setShippedItemsPackageDialogOpen(false)}
      />
      <Paper style={{ borderRadius: 20 }}>
        <Box pt={6} pl={10} pr={10}>
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="baseline" mb={4}>
              <Box fontSize={34} color="#001C56" mr={1}>
                {totalShipped}
              </Box>
              <Box fontSize={21} color="#001C56">
                Colis expédiés
              </Box>
              <ExportCsvButton
                onClick={() => {
                  const columns = ['Transporteur', 'Quantité', 'Pourcentage (%)'];
                  const rows = shippedQuantitiesByCarrier.map(s => [
                    s.carrier.name,
                    s.quantity,
                    totalShipped > 0
                      ? ((s.quantity * 100) / totalShipped).toFixed(2)
                      : '0'
                  ]);
                  exportToCsv('colis_expedies_par_transporteur', columns, rows);
                }}
                onExcelClick={() => {
                  const columns = ['Transporteur', 'Quantité', 'Pourcentage (%)'];
                  const rows = shippedQuantitiesByCarrier.map(s => [
                    s.carrier.name,
                    s.quantity,
                    totalShipped > 0
                      ? ((s.quantity * 100) / totalShipped).toFixed(2)
                      : '0'
                  ]);
                  exportToExcel('colis_expedies_par_transporteur', columns, rows);
                }}
              />
            </Box>
            <PeriodicityButton
              onChange={({ dateFrom, dateTo }) => {
                dispatchGetShippedByCarrier({ dateFrom, dateTo });
              }}
            />
          </Box>

          {loadingShippedQuantitiesByCarrier ? (
            <Box display="flex" justifyContent="center" p={20}>
              <CircularProgress size={60} />
            </Box>
          ) : (
            <HighchartsReact highcharts={Highcharts} options={options} />
          )}
        </Box>
        <Divider />
        <ShowMoreButton
          onClick={() => setShippedItemsPackageDialogOpen(true)}
        />
      </Paper>
    </div>
  );
};

const mapStateToProps = state => ({
  shippedQuantitiesByCarrier: state.dashboard.shippedQuantitiesByCarrier,
  loadingShippedQuantitiesByCarrier:
    state.dashboard.loadingShippedQuantitiesByCarrier
});

const mapDispatchToProps = dispatch => ({
  dispatchGetShippedByCarrier: params => dispatch(getShippedByCarrier(params))
});

ShippedPackageChart.propTypes = {
  shippedQuantitiesByCarrier: PropTypes.array,
  dispatchGetShippedByCarrier: PropTypes.func,
  loadingShippedQuantitiesByCarrier: PropTypes.bool
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShippedPackageChart);
